import client from './apiConnector';

async function addGeoJson(name, rawData) {
  return client().post('/geometry', { name, geojson: rawData });
}

async function getGeojson(id) {
  return client().get(`/geometry/${id}`);
}

async function getGeojsonInfos(id) {
  return client().get(`/geometry/${id}/infos`);
}

async function updateGeoJson(id, name, rawData) {
  return client().put(`/geometry/${id}`, { name, geojson: rawData });
}

async function deleteGeoJson(id) {
  return client().delete(`/geometry/${id}`);
}

export default {
  addGeoJson,
  getGeojson,
  getGeojsonInfos,
  updateGeoJson,
  deleteGeoJson,
};
